<template>
  <div
    id="knowledge-container"
    class="knowledge-test-container"
  >
    <div class="knowledge-test-container--item">
      <Header/>
    </div>
    <div class="section-gray">
      <div
        v-if="!user.hasOwnProperty('knowledgeTestPoint')"
        class="knowledge-test-container--content"
      >
        <div class="section-white">
          <KulapPlusKycCard />
        </div>
      </div>
      <div v-else>
        <SummaryOfKnowledgeTest
          :knowledge-test-point="user.knowledgeTestPoint"
          :is-submit-suitability-test="user.hasOwnProperty('suitabilityTestPoint')"
        />
      </div>
    </div>
    <div class="knowledge-test-container--item">
      <Footer/>
    </div>
  </div>
</template>

<script>
import Header from '@/features/Header'
import Footer from '@/components/Footer'
import SummaryOfKnowledgeTest from '@/components/SummaryOfKnowledgeTest'
import KnowledgeTestAnswers from '@/assets/json/knowledgeTestAnswersV2'
import { mapState } from 'vuex'
import cookie from '@/utils/cookie'
import Service from './service.js'
import { kulapApi } from '@/resources'
import { showToastError } from '@/utils/helper'
import AmplitudeService from '@/services/amplitude'
import KulapPlusKycCard from '@/pages/KYC/components/kulapPlusKycCard'

export default {
  name: 'KnowledgeTest',
  components: {
    Header,
    Footer,
    SummaryOfKnowledgeTest,
    KulapPlusKycCard
  },
  data () {
    return {
      service: null,
      knowledgeTestAns: KnowledgeTestAnswers,
      questionIds: [],
      form: [],
      isLoadingSubmit: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    })
  },
  async created () {
    if (!cookie.get('user') || !cookie.get('accessToken')) {
      this.$router.push({ name: 'Login', query: { next: 'KnowledgeTest' } })
      return
    }
    this.service = new Service({
      store: this.$store,
      kulapApi
    })
    const user = await this.service.getUserProfile()
    if (!user.isActive) {
      this.$router.push({ name: 'Exchange' })
    }
    this.$scrollTo('#knowledge-container')
    this.randomIdOfQuestion()
  },
  methods: {
    async submit () {
      const validateFieldResult = await this.$validator.validate()
      if (!validateFieldResult) {
        const convertNameToId = Object.keys(this.errors.collect())[0].toLowerCase().replace(/ /g, '-').replace(/[()?.]/g, '')
        this.$scrollTo(`#${convertNameToId}`)
        return
      }
      this.isLoadingSubmit = true
      try {
        const reulst = await this.service.submitKnowledgeTest(this.form)
        this.trackQuestion('Submit knowledge-test success')
        if (reulst.success) {
          this.$buefy.toast.open({
            message: `Success !`,
            type: 'is-success'
          })
          this.$router.push({ name: 'KnowledgeTestCorrectAnswer' })
        } else {
          this.$buefy.toast.open({
            message: `Sorry, something went wrong.`,
            type: 'is-danger'
          })
        }
      } catch (e) {
        showToastError(e)
      }
      this.isLoadingSubmit = false
    },
    randomIdOfQuestion () {
      let currentNo = 0
      for (let id in this.knowledgeTestAns) {
        const randomCount = id === 'cryptocurrency' ? 4 : 2
        const tempRandoms = this.randomItem(Object.keys(this.knowledgeTestAns[id]), randomCount)
        this.questionIds.push(tempRandoms.map(data => {
          ++currentNo
          return {
            no: currentNo,
            group: id,
            qid: data
          }
        }))
      }
      this.questionIds = this.questionIds.flat()
      this.$forceUpdate()
    },
    randomItem (arr, size) {
      return arr.map(a => [a, Math.random()]).sort((a, b) => { return a[1] < b[1] ? -1 : 1 }).slice(0, size).map(a => a[0])
    },
    trackQuestion (group, qId) {
      let eventProp = {
        knowledgeGroup: group,
        questionNumber: qId
      }
      AmplitudeService.inputQuestion('EVENT_KNOWLEDGE_TEST', eventProp)
    }
  }
}
</script>

<style lang="scss" scoped>
.others-input-box {
  margin-top: 10px;
  width: 40%;
  min-width: 300px;
}
.knowledge-test-container {
  float: left;
  width: 100%;
  min-height: 100vh;
  &--item {
    float: left;
    width: 100%;
  }
  &--content {
    max-width: 1024px;
    margin: 0 auto;
  }
}
.section-gray {
  float: left;
  width: 100%;
  padding-bottom: 80px;
}

.knowledge-test-title {
  margin: 35px 0;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  color: #000000;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.question {
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.3px;
  color: #000000;
}
.answers {
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 30px;
  .answer {
    font-family: Roboto;
    font-size: 14px;
    color: #000000;
    margin-bottom: 20px;
  }
}
.submit-btn {
  display: flex;
  justify-content: center;
  width: 165px;
  height: 45px;
  border-radius: 3px;
  border: unset;
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.5);
  background-color: #2193ff;
  margin: 50px auto 0;
  font-family: Roboto;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  text-align: center;
  color: #ffffff;
  padding: 13px 0px;
  cursor: pointer;
}
.skeleton-container {
  margin-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/KnowledgeTest/index.vue